import React from 'react'

export const WarehouseReports = (props) => {
    return (
        <div>WarehouseReports</div>
    )
}


